// @flow
import styled, { css } from "styled-components";
import { sectionHeading } from "@nested/brand";
import { Link } from "./Link";

export const blogWrapperStyles = css`
  max-width: 534px;
  padding-left: 20px;
  padding-right: 20px;
  margin-left: auto;
  margin-right: auto;
`;

const H6 = styled.h6`
  ${sectionHeading}
`;

const OuterWrapper = styled.div`
  ${blogWrapperStyles}
  padding-bottom: 20px;
`;

const BreadcrumbWrapper = styled.div`
  display: inline;
  &:not(:first-child) :before {
    content: url("https://nested.imgix.net/icons/chevron_right.svg");
    margin-right: 10px;
    opacity: 0.5;
    margin-left: 10px;
    position: relative;
    top: 3px;
    width: 16px;
    height: 16px;
  }
`;

const Breadcrumb = ({ link, label }) => (
  <BreadcrumbWrapper>
    <Link to={link}>
      <H6 as="span" data-test="breadcrumb" left>
        {label}
      </H6>
    </Link>
  </BreadcrumbWrapper>
);

type Props = {
  category: PrismicCategory,
};

const Breadcrumbs = ({ category }: Props) => (
  <OuterWrapper>
    <Breadcrumb link="/blog" label="Blog" />
    <Breadcrumb
      link={`/blog/categories/${category.uid}`}
      label={category.data.name}
    />
  </OuterWrapper>
);

export { Breadcrumbs };
